import { gql } from '@apollo/client'

export const POSITIONS_TREE_QUERY = gql`
  query POSITIONS_TREE_QUERY($pagination: PaginationInput, $filter: PositionFilterInput) {
    positions(pagination: $pagination, filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        code
        active
        expanded
        parentId
        description
        createdAt

        user {
          id
          firstName
          lastName
        }

        parent {
          id
          description
        }
      }
    }
  }
`

export const POSITIONS_SELECT_QUERY = gql`
  query POSITIONS_SELECT_QUERY($filter: PositionFilterInput) {
    positions(filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        active
        description
        parent {
          id
          description
        }
      }
    }
  }
`
